export const SET_FEED_CONTENT = "FEED/SET_FEED_CONTENT";
